import Slots from "./Slots"

export default Slots